module.exports = __webpack_public_path__ + "img/printing.e2975cc8.svg";